module.exports = __webpack_public_path__ + "img/TCPL3.png";